<script setup lang="ts">
const { $ts } = useI18n()
</script>

<template>
  <div :data-test="getCypressId('body-header')" flex flex-col gap-24px items-center text-center mt-72px>
    <h1 heading1 text-neutral-900 font-800>
      {{ $ts('pages.faq.title') }}
    </h1>
    <h3 text-neutral-900 paragraph-md max-w-648px>
      {{ $ts('pages.faq.subtitle') }}
    </h3>
  </div>
  <FaqItems show-tabs for="customers" />
</template>
